<template>
  <div
    id="ClockIn_main"
    v-loading.fullscreen.lock="clockInFullscreenLoading"
  >
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="clockInDialog"
      :close-on-click-modal="false"
      width="30%"
    >
      <div
        class="showWebCam"
        :style="`background-image: url(${webcamUrl})`"
      />
      <span slot="footer">
        <el-button
          round
          @click="dialogVisible = false"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="submitWebCam"
        >確認</el-button>
      </span>
    </el-dialog>
    <ReadClockCard
      ref="readClockCard"
      @sandClockCard="sandClockCard"
      @disposable="disposable"
    />
    <DisposableClockIn ref="disposableClockIn" />
  </div>
</template>
<script>
import ReadClockCard from './ReadClockCard'
import DisposableClockIn from './DisposableClockIn'
export default {
  components: {
    ReadClockCard,
    DisposableClockIn
  },
  data () {
    return {
      dialogVisible: false,
      webcamUrl: '',
      requestData: new FormData(),
      clockInFullscreenLoading: false
    }
  },
  mounted () {
  },
  methods: {
    startClockIn (data) {
      console.log(data)
      if (data.webcamUrl !== '') {
        this.dialogVisible = true
        this.webcamUrl = data.webcamUrl
        this.requestData.append('ClockImgFile', data.webcamFile)
      } else {
        this.$refs.readClockCard.openDialog()
      }
      if (data) {
        this.requestData.append('Longitude', 0)
        this.requestData.append('Latitude', 0)
        this.requestData.append('IsWarning', data.isWarning)
      }
    },
    submitWebCam () {
      this.dialogVisible = false
      this.$refs.readClockCard.openDialog()
    },
    // 掃描結束回傳感應卡code
    sandClockCard (code) {
      this.clockInFullscreenLoading = true
      this.requestData.append('ClockCard', code)
      apiAttendanceManagement.ClockIn.PostClockCardValidation(
        {
          ClockCard: code
        }
      ).then(res => {
        // 打卡成功
        if (res.data.Status === 1) { // 載具有綁定實名制帳號（社區管理人員帳號）
          if (res.data.Data.IsInCompany) { // 有在企業雲
            this.clockIn()
          } else {
            this.$alert('物業公司尚未加入您的社區管理人員帳號，請輸入個人資料，以核實打卡紀錄。', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              callback: action => {
                this.$refs.disposableClockIn.openDialog(this.requestData, res.data.Data.AuthorizationInfo)
              }
            })
          }
        }
        this.clockInFullscreenLoading = false
      }).catch(err => {
        if (err.response.data.ErrorMessage.Code === 400000) {
          this.$confirm('您尚未註冊社區管理人員帳號，請點選註冊申辦。', '警告', {
            confirmButtonText: '註冊',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            localStorage.setItem('loginStatus', false)
            this.$router.push({ name: 'LoginMain', params: { page: 'rigister' } })
          }).catch(() => {})
        }
        this.clockInFullscreenLoading = false
        console.log('錯誤訊息：', err.response)
      })
    },
    // 開啟掃描彈窗後，選擇一次性打卡
    disposable () {
      this.$refs.disposableClockIn.openDialog(this.requestData)
    },
    // 合法載具打卡上班
    clockIn () {
      this.clockInFullscreenLoading = true
      apiAttendanceManagement.ClockIn.PostClockIn(
        this.requestData
      ).then(res => {
        console.log(res)
        // 打卡成功
        if (res.data.Status === 1) {
          this.$message({
            message: res.data.Data.Name + '打卡成功，刷卡時間為：' + res.data.Data.ClockTime,
            type: 'success'
          })
          this.$router.push({ name: 'AttendanceManagement' })
        }
        this.clockInFullscreenLoading = false
      }).catch(err => {
        this.clockInFullscreenLoading = false
        console.log('錯誤訊息：', err.response)
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#ClockIn_main
  ::v-deep .el-dialog.clockInDialog
    +basicDialog
    .el-dialog__header
      background-color: $white
    .showWebCam
      width: 640px
      height: 400px
    .el-dialog__footer
      text-align: center
</style>
